/**
 * Checkout intent — preserves a guest's plan selection across the auth detour.
 *
 * Auth-first checkout: an unauthenticated visitor who clicks a paid plan is sent
 * to sign up / log in first. We stash their selection (plan, billing cycle, promo)
 * in localStorage so it survives the redirect — including the external OAuth/SSO
 * round-trip (same origin) — then CheckoutResume picks it up once they're authed.
 *
 * Client-side only + advisory: the price is always derived server-side from the
 * plan→product map and the promo is re-validated by the backend, so a tampered
 * intent cannot change what's charged.
 */
const KEY = "ll_checkout_intent";
const MAX_AGE_MS = 30 * 60 * 1000; // 30 min — stale intents are ignored

export function saveCheckoutIntent({ plan, billing, promo }) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ plan, billing, promo: promo || null, ts: Date.now() }));
  } catch {
    /* localStorage unavailable — intent simply won't persist */
  }
}

export function readCheckoutIntent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const intent = JSON.parse(raw);
    if (!intent?.plan || !intent?.ts || Date.now() - intent.ts > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return intent;
  } catch {
    return null;
  }
}

export function clearCheckoutIntent() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
